import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChangeAccountDescriptionComponent, } from "generated/generated-models";
import { Formik, Form } from "formik";
import { Guid } from "guid-typescript";
import { CInputFormGroup } from "app/common/forms/CInputFormGroup";
import { nameof } from "core/util/nameof";
import { Loading } from "app/lib/components/Loading";
import { yupChangeAccountDescriptionInput } from "./yupChangeAccountDescriptionInput";
import { Grid, Button } from "@mui/material";
const ChangeAccountDescription = ({ accountId, previousDescription, onCancel, onUpdated, }) => {
    return (_jsxs("div", { className: "cap-change-account-description", children: [_jsx(ChangeAccountDescriptionComponent, { children: (mutateFn, { called, data, loading }) => (_jsx(Formik, { initialValues: {
                        AccountId: accountId.toString(),
                        Name: previousDescription,
                    }, validationSchema: yupChangeAccountDescriptionInput, onSubmit: (values) => {
                        mutateFn({
                            variables: {
                                input: {
                                    AccountId: values.AccountId,
                                    Name: values.Name,
                                    clientMutationId: Guid.create().toString(),
                                },
                            },
                        }).then(() => {
                            onUpdated();
                        });
                    }, children: ({ values }) => {
                        const isDisabled = () => {
                            if (called && loading) {
                                return true;
                            }
                            else {
                                return (data?.changeAccountDescription
                                    ?.Success ?? false);
                            }
                        };
                        return (_jsxs(Form, { children: [_jsx(Grid, { container: true, spacing: 2, children: _jsx(Grid, { item: true, xs: 6, children: _jsx(CInputFormGroup, { fieldName: nameof("Name"), label: "Account Name:", inputClassName: "form-control account-name-edit", fieldWrapper: (fieldNode) => {
                                                return (_jsxs("div", { className: "form-group button-row", children: [fieldNode, _jsx(Button, { type: "submit", id: "submit", sx: {
                                                                p: 1.5,
                                                                mr: 1,
                                                            }, variant: "contained", children: "Save" }), _jsx(Button, { className: "btn-cancel", sx: { p: 1.5 }, variant: "contained", onClick: onCancel, disabled: isDisabled(), id: "cancel", children: "Cancel" })] }));
                                            } }) }) }), called && loading && _jsx(Loading, {})] }));
                    } })) }), " "] }));
};
export { ChangeAccountDescription as ChangeAccountDescriptionComponent };
